import Description from "./Description";
import Header from "./Header";

const Hero = () => {
  return (
    <div style={{ position: "relative" }}>
      <Header />

      <Description />
    </div>
  );
};

export default Hero;
